export interface IFrontPageRecords {
    userRecordCount: number;
    userDateRange: number;
    companyRecordCount: number;
    companyDateRange: number;
}

export class FrontPageRecords implements IFrontPageRecords {
    userRecordCount: number;
    userDateRange: number;
    companyRecordCount: number;
    companyDateRange: number;

    constructor();
    constructor(obj: IFrontPageRecords);
    constructor(obj?: any) {
        this.userRecordCount = obj && obj.userRecordCount || 0;
        this.userDateRange = obj && obj.userDateRange || 0;
        this.companyRecordCount = obj && obj.companyRecordCount || 0;
        this.companyDateRange = obj && obj.companyDateRange || 0;
    }
}